const subdomainValidator = (value) => {
    if (!value) return true;

    if (value === "@") return true;

    const regex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return regex.test(value) ? true : "validate.subdomain_format";
};

export { subdomainValidator }; 